import { useNavigate, useLocation } from "react-router-dom";

export function useMyNavigate() {
  const navigate = useNavigate();
  const location = useLocation();

  function myNavigate(route: string, state?: any) {
    navigate(route + location.search, state);
  }

  return myNavigate;
}